import { render, staticRenderFns } from "./MoleculeFeedAssetsContentModalInscripcionActiva.vue?vue&type=template&id=3887ff08&"
import script from "./MoleculeFeedAssetsContentModalInscripcionActiva.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedAssetsContentModalInscripcionActiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports